import { Component, Inject } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MD_DIALOG_DATA, MdDialogRef } from "@angular/material";
import Swal from "sweetalert2";
import { IBillingShippingModel } from "../../../interfaces/LicenseModel";
import { LicenseService } from "../../../services/LicenseService";
import { AppLoaderService } from "../../../../services/app-loader/app-loader.service";
import { Router } from "@angular/router";
import { AdalService } from "../../../shared/adal.service";

@Component({
    template:require('./add-lz30-device-license-request.component.html'),
    selector:'add-lz30-device-license-request',
    styles:[require('./add-lz30-device-license-request.component.css')]
})
export class AddLz30DeviceLicenseRequest{
    dialogTitle='Generate LZ30 Device License'
    errorMessage=''
    lz30LicenseForm;
    lz30PurchaseLicenseDisplayData;
    shouldFetchSalesOrderNo=true;
    error='';
    rowClicked=-1;
    userDeviceDisplayData;
    DeviceList=[];
    prevSalesOrderNo='';
    billingShippingDetail:IBillingShippingModel={
        ODataEtag:'',
        Number:'',
        publicId:'',
        CustomerNo:'',
        publicSalesPersoncode:'',
        BillToName:'',
        BillToAddress1:'',
        BillToAddress2:'',
        BillToCity:'',
        BillToState:'',
        BillToZipcode:'',
        BillToCountryCode:'',
        ShipToCode:'',
        ShipToName:'',
        ShipToAddress1:'',
        ShipToAddress2:'',
        ShipToCity:'',
        ShipToState:'',
        ShipToZipcode:'',
        ShipToCountryCode:'',
        CustomerTelephone:'',
        CustomerEmailAddress:'',
        CustomerFaxno:'',
        ShippingTelephoneno:'',
        ShippingFaxno:'',
        ShippingEmailAddress:'',
        Rep1:'',
        Rep2:'',
        Sales1:'',
        Sales2:''
    };
    isBillingShippingDetailFetched=false;
    SelectedCustomerDetail;
    isAddButtonClicked=false;
    constructor(
        private formBuilder:FormBuilder,
        private dialogRef:MdDialogRef<AddLz30DeviceLicenseRequest>,
        private licenseService:LicenseService,
        private appLoader:AppLoaderService,
        private adalService:AdalService,
        private router:Router,
        @Inject(MD_DIALOG_DATA) public dialogData
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        this.buildForm()
        this.userDeviceDisplayData=dialogData.userDeviceDisplayData;
        this.lz30PurchaseLicenseDisplayData=dialogData.purchaseLicenseDisplayData;
        this.SelectedCustomerDetail=dialogData.SelectedCustomerDetail;
        if(this.SelectedCustomerDetail!=null){
            this.dialogTitle='Add More LZ30 License';
            this.isBillingShippingDetailFetched=true;
            this.SelectedCustomerDetail.SalesOrderNo='';
            this.billingShippingDetail.BillToName=this.SelectedCustomerDetail.BillToName;
            this.billingShippingDetail.BillToAddress1=this.SelectedCustomerDetail.BillToAddress1;
            this.billingShippingDetail.BillToAddress2=this.SelectedCustomerDetail.BillToAddress2;
            this.billingShippingDetail.BillToCity=this.SelectedCustomerDetail.BillToCity;
            this.billingShippingDetail.ShipToName=this.SelectedCustomerDetail.ShipToName;
            this.billingShippingDetail.ShipToAddress1=this.SelectedCustomerDetail.ShipToAddress1;
            this.billingShippingDetail.ShipToAddress2=this.SelectedCustomerDetail.ShipToAddress2;
            this.billingShippingDetail.ShipToCity=this.SelectedCustomerDetail.ShipToCity;
            this.billingShippingDetail.ShipToState=this.SelectedCustomerDetail.ShipToState;
        }
    }
    buildForm(){
        this.lz30LicenseForm=this.formBuilder.group({
            PurchaseDate:['',Validators.required],
            NoOfMonths:['',Validators.required],
            SalesOrderNo:['',Validators.required],
            Devices:this.formBuilder.array([this.createDevice(null)])
        })
    }
    
    createDevice(data):FormGroup{
        data = data || { SerialNo:null,StartDate:''}
        return this.formBuilder.group({
            SerialNo:[data.SerialNo],
            StartDate:[data.StartDate]
        })
    }
    get devices(){
        return this.lz30LicenseForm.get('Devices') as FormArray;
    }
    addDevice(index){
        const currentDevice=this.devices.controls[index].get('SerialNo').value
        const currentDeviceStartDate=this.devices.controls[index].get('StartDate').value
        // const SerialNoError=this.devices.controls[index].get('SerialNo').errors
        // const DateError=this.devices.controls[index].get('StartDate').errors
        // if((SerialNoError && SerialNoError.required ) || (DateError && DateError.required )){
        //     return;   
        // }
        this.errorMessage=''
        if(currentDevice==null || currentDeviceStartDate==''){
            // this.isAddButtonClicked=true;
            this.errorMessage='Serial No or Start date cannot be empty.'
            return ;
        }
        const filteredDeviceList=this.DeviceList.filter((device)=>{
            return device.MACAddress==currentDevice.MACAddress
        })
        if(filteredDeviceList.length>0){
            this.errorMessage='This device already exists.'
            return ;
        }
        this.DeviceList.push({
            LZ30DeviceId:currentDevice.LZ30DeviceId,
            MACAddress:currentDevice.MACAddress,
            DeviceStartDate:currentDeviceStartDate
        });
        this.rowClicked=index;
        this.devices.push(this.createDevice(null))
    }
    removeDevice(index){
        this.devices.removeAt(index);
        this.DeviceList.splice(index,1);
        this.rowClicked--;
    }
    onSave(){
        setTimeout(() => {
            if(!this.isBillingShippingDetailFetched){
                this.error="Please fetch the customer billing and shipping details!";
                return;
            }
            if(this.DeviceList==null || this.DeviceList.length<=0){
                Swal.fire({
                    title:'Serial Number Empty',
                    text:'Please add atleast one Serial Number.',
                    showConfirmButton:true,
                    confirmButtonColor:'#FFCA28'
                })
                return ;
            }
            if(this.SelectedCustomerDetail!=null){
                this.appLoader.open()
                if(this.lz30LicenseForm.value.SalesOrderNo.toUpperCase()!=this.SelectedCustomerDetail.SalesOrderNo.toUpperCase()){
                    this.licenseService.addBillingShippingDetail(this.billingShippingDetail).subscribe((data)=>{
                        let model={
                            LZ30UserDeviceId:this.SelectedCustomerDetail.LZ30UserDeviceId,
                            PurchaseDate:this.lz30LicenseForm.value.PurchaseDate,
                            SalesOrderNo:this.lz30LicenseForm.value.SalesOrderNo,
                            NoOfMonths:this.lz30LicenseForm.value.NoOfMonths,
                            CustomerId:data.DataObject.CustomerId,
                            ShippingAddressId:data.DataObject.ShippingAddressId,
                            NoOfDevicePurchased:this.DeviceList.length,
                            LZ30LicenseInfo:this.DeviceList,
                            CreatedBy:Number(localStorage.getItem('userid')),
                            UpdatedBy:Number(localStorage.getItem('userid'))
                        }
                        this.licenseService.addMoreLZ30License(model).subscribe((data)=>{
                            if(!data.IsError && data.DataObject!=null){
                                this.dialogRef.close(data.DataObject);
                            }
                            this.appLoader.close();
                        })
                    })
                }
                else{
                    let model={
                        LZ30UserDeviceId:this.SelectedCustomerDetail.LZ30UserDeviceId,
                        CustomerId:this.SelectedCustomerDetail.CustomerId,
                        ShippingAddressId:this.SelectedCustomerDetail.ShippingAddressId,
                        PurchaseDate:this.lz30LicenseForm.value.PurchaseDate,
                        SalesOrderNo:this.lz30LicenseForm.value.SalesOrderNo,
                        NoOfMonths:this.lz30LicenseForm.value.NoOfMonths,
                        NoOfDevicePurchased:this.DeviceList.length,
                        LZ30LicenseInfo:this.DeviceList,
                        CreatedBy:Number(localStorage.getItem('userid')),
                        UpdatedBy:Number(localStorage.getItem('userid'))
                    }
                    this.licenseService.addMoreLZ30License(model).subscribe((data)=>{
                        if(!data.IsError && data.DataObject!=null){
                            this.dialogRef.close(data.DataObject);
                        }
                        this.appLoader.close();
                    })
                }
                
            }
            else{
                this.appLoader.open()
                this.licenseService.addBillingShippingDetail(this.billingShippingDetail).subscribe((data)=>{
                    let model={
                        PurchaseDate:this.lz30LicenseForm.value.PurchaseDate,
                        SalesOrderNo:this.lz30LicenseForm.value.SalesOrderNo,
                        NoOfMonths:this.lz30LicenseForm.value.NoOfMonths,
                        CustomerId:data.DataObject.CustomerId,
                        ShippingAddressId:data.DataObject.ShippingAddressId,
                        NoOfDevicePurchased:this.DeviceList.length,
                        LZ30LicenseInfo:this.DeviceList,
                        CreatedBy:Number(localStorage.getItem('userid')),
                        UpdatedBy:Number(localStorage.getItem('userid'))
                    }
                    this.licenseService.purchaseLz30License(model).subscribe((data)=>{
                        if(!data.IsError && data.DataObject!=null){
                            this.dialogRef.close(data.DataObject);
                        }
                        this.appLoader.close()
                    })
                })
            }
        }, 300);
        
    }
    blurSalesOrderEvent(){
        if(this.prevSalesOrderNo.trim().toUpperCase()==this.lz30LicenseForm.value.SalesOrderNo.trim().toUpperCase()){
            return;
        }
        this.prevSalesOrderNo=this.lz30LicenseForm.value.SalesOrderNo
        setTimeout(() => {
            this.shouldFetchSalesOrderNo=true;
            this.isBillingShippingDetailFetched=false;
        }, 150);
    }
    checkSalesOrderNo(){
        if(this.lz30PurchaseLicenseDisplayData){
            console.log(this.lz30PurchaseLicenseDisplayData)
            let exist=this.lz30PurchaseLicenseDisplayData.some(element => {
                if(element.SalesOrderNo!=null){
                    return this.lz30LicenseForm.value.SalesOrderNo.trim().toUpperCase()==element.SalesOrderNo.trim().toUpperCase()
                }
                else{
                    return false;
                }
            });
            if(exist){
                Swal.fire({
                    title:"This sales order no already exists",
                    text:"Are you sure you want to use this Sales Order No?",
                    showCancelButton:true,
                    showCloseButton:true,
                    showConfirmButton:true,
                    confirmButtonText:"Yes",
                    confirmButtonColor:"#FFCA28",
                    cancelButtonText:"No",
                }).then((result)=>{
                    if(result.isConfirmed){
                       this.shouldFetchSalesOrderNo=true;
                       this.isBillingShippingDetailFetched=false;
                       this.getBillingShippingDetail()
                    }
                    else{
                        this.shouldFetchSalesOrderNo=false;
                        this.lz30LicenseForm.patchValue({
                            SalesOrderNo:""
                        });
                    }
                })
            }
            else{
                this.shouldFetchSalesOrderNo=true;
                this.isBillingShippingDetailFetched=false;
                this.getBillingShippingDetail()
            }
        }
        else{
            this.shouldFetchSalesOrderNo=true;
            this.isBillingShippingDetailFetched=false;
            this.getBillingShippingDetail()
        }
    }
    getBillingShippingDetail(){
        let salesOrderNo=this.lz30LicenseForm.value.SalesOrderNo;
        if(salesOrderNo!=''){
            if(this.shouldFetchSalesOrderNo){
                this.appLoader.open();
                this.licenseService.getBillingShippingDetail(salesOrderNo).subscribe((data)=>{ //get data from MAS90
                    if(!data.IsError && data.DataObject!=null){
                        this.billingShippingDetail=data.DataObject;
                        this.isBillingShippingDetailFetched=true;
                        this.error='';
                    }
                    else{
                        this.isBillingShippingDetailFetched=false;
                        this.error=data.Error;
                    }
                    this.appLoader.close();
                })
                
            }
            else{
                this.error="Please select other sales order number."
            }
        }
        else{
            this.error="Sales Order No is required";
            this.isBillingShippingDetailFetched=false;
        }
    }
    onCancel(){
        this.dialogRef.close(this.lz30PurchaseLicenseDisplayData)
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/lz30/add-lz30-device-license-request/add-lz30-device-license-request.component.ts